import { gql } from '@apollo/client';

export default gql`
  query PricingPage($languages: [String], $url_key: String, $status: String) {
    content {
      pricing_pages(
        filter: { url_key: { _eq: $url_key }, status: { _eq: $status } }
      ) {
        title
        title_color
        translations(
          filter: { languages_code: { code: { _in: $languages } } }
        ) {
          page_title
          meta_title
          meta_description
        }
        layout {
          collection
          item {
            __typename
            ... on pricing_pages_single_layout {
              ...singleLayout
            }
            ... on pricing_pages_multi_layout {
              ...multiLayout
            }
          }
        }
      }
    }
  }

  fragment singleLayout on pricing_pages_single_layout {
    content(
      limit: 1
      filter: { languages_code: { code: { _in: $languages } } }
    ) {
      bottom_content
      languages_code {
        code
      }
    }
    show_retailer_button
    product {
      title
      sku
      image {
        filename_disk
      }
      links {
        products_links_id(filter: { status: { _eq: $status } }) {
          translations(
            filter: { languages_code: { code: { _in: $languages } } }
          ) {
            title
            url
            languages_code {
              code
            }
          }
        }
      }
      system_requirements {
        system_requirements_id {
          translations(
            filter: {
              languages_code: { code: { _in: $languages } }
              status: { _eq: $status }
            }
          ) {
            languages_code {
              code
            }
            content
          }
        }
      }
      translations(
        filter: {
          languages_code: { code: { _in: $languages } }
          status: { _eq: $status }
        }
      ) {
        subtitle
        additional_information
        product_includes
        system_requirments
        languages_code {
          code
        }
      }
    }
  }

  fragment multiLayout on pricing_pages_multi_layout {
    grid_columns
    show_retailer_button
    links {
      translations(
        filter: {
          languages_code: { code: { _in: $languages } }
          status: { _eq: $status }
        }
      ) {
        title
        url
        languages_code {
          code
        }
      }
    }
    translations(filter: { languages_code: { code: { _in: $languages } } }) {
      content_top
      content_bottom
      find_dealer_text
      extra_information
      languages_code {
        code
      }
    }
    products {
      products_id(filter: { status: { _eq: $status } }) {
        title
        sku
        image {
          filename_disk
        }
        translations(
          filter: {
            languages_code: { code: { _in: $languages } }
            status: { _eq: $status }
          }
        ) {
          subtitle
          system_requirments
          multiproduct_layout_content
          languages_code {
            code
          }
        }
      }
    }
  }
`;
